import { render, staticRenderFns } from "./RevokeAgreement.vue?vue&type=template&id=1e3e52b8"
import script from "./RevokeAgreement.vue?vue&type=script&lang=js"
export * from "./RevokeAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports